module.exports = __webpack_public_path__ + "img/list1.c5e5c07b.png";